import { keepPreviousData } from '@ubisend/pulse-hooks';

const query = {
  placeholderData: keepPreviousData,
  staleTime: Infinity
};

export default query;
